import React from "react";
import PropTypes from "prop-types";
// import * as chartCreators from "react-chartkick";
import chartCreators from "../custom_react_chartkick";
import $ from "jquery";

import { evalHelper } from "../tariff_survey_hub/utils";
import AddToSlideDeckOverlay from "../tariff_survey_hub/containers/add_to_slide_deck_overlay";
import DownloadButton from "./download_button";

class ChartkickChart extends React.Component {
  constructor(props) {
    super(props);

    this.chartContainerWrapper = React.createRef();
  }

  // Implement in subclass to inject, ie. hover and click handlers that might dispatch actions.
  // gets called within .render()
  customizeOptions(options, props) {
    props;
    // Safe to mutate, the actual prop is just a string so this wouldn't count as mutating a prop.
    const modifiedOptions = options;

    return modifiedOptions;
  }

  getSnapshotBeforeUpdate() {
    // Runs during the commit phase, before the new render is flushed to the DOM —
    // the existing (pre-update) chart is still present here, matching the old
    // componentWillUpdate timing. this.props already holds the incoming props.
    this._mutateChartBeforeRender(this.props);
    return null;
  }

  componentDidMount() {
    this._mutateChartAfterRender();
  }

  componentDidUpdate() {
    this._mutateChartAfterRender();
  }

  componentWillUnmount() {
    // TODO(SI): currently when the component rerenders it generates a new chart(I think) and destroys the previous one
    // however when the component is fully unmounted it leaves the previous one undestroyed.
    // This slowly leaks memory, in Highcharts.charts references(and possibly other locations.)
    //
    // That being said, setting Highcharts.charts = [] seems to totally disconnect it from ChartKick. ... So leak
    // might still be there by hidden? ugh
    //
    // Might have to check where else references to the chart are leaked. Maybe try and call destroy/remove on the
    // chartkick instance if I can grab it.
    //
    // TODO(SI): leave an issue on the react-chartkick repo when I figure out the problem.
    //
    //
    //

    const chart = this.highchartsChart();
    if (!chart) { return; }

    chart.destroy();
  }

  _mutateChartAfterRender() {
    const chart = this.highchartsChart();

    if (!chart) { return; }

    chart.legendShow();

    this.mutateChartAfterRender(chart);
  }

  _mutateChartBeforeRender(nextProps) {
    const chart = this.highchartsChart();

    if (!chart) { return; }

    this.mutateChartBeforeRender(chart, nextProps);
  }

  chartDomObject() {
    if (!window) { return; }
    if (!this.chartContainerWrapper.current) { return; }

    return $(this.chartContainerWrapper.current).find("[data-highcharts-chart]");
  }

  highchartsChart() {
    const $chartWrapper = this.chartDomObject();
    if (!$chartWrapper || $chartWrapper.length === 0) { return; }
    // TODO(SI): if I do jquery .data().highchartsChart it returns 0 or something. Maybe the way chartkick is
    // creating and modifiny the data attribute does not update beyond the data-highcharts-chart attribute....
    // as in the return value of data() is cached somehwere? wughh
    const index = $chartWrapper[0].getAttribute("data-highcharts-chart");

    return window.Highcharts.charts[+index];
  }

  // Implement in subclass to handle, ie. making some point or column or stacked column stack highlighted if
  // global state requires that. For instance highlight current country.
  //
  // Base this off of this.props.
  //
  // eslint-disable-next-line no-unused-vars
  mutateChartBeforeRender(chart, nextProps) {
  }

  // Implement in subclass to handle, ie. making some point or column or stacked column stack highlighted if
  // global state requires that. For instance highlight current country.
  //
  // Base this off of this.props.
  //
  // eslint-disable-next-line no-unused-vars
  mutateChartAfterRender(chart) {
  }

  containerStyles() {
    return {};
  }

  enableAddToSlideDeck() {
    return true;
  }

  svgString() {
    const $chartWrapper = this.chartDomObject();
    if (!$chartWrapper || $chartWrapper.length === 0) { return; }

    const svgClone = $($chartWrapper.find("svg").prop("outerHTML"));
    svgClone.find(".highcharts-button").remove(); // The Redux action in which we call svgString is the same as the one that causes the button prop to change. So the button is actualyl visible while we are calling this method sadly.

    return svgClone.prop("outerHTML");
  }

  render () {
    if (!this.props.dataAndOptions) { return <div></div>; }

    const chartDataAndOptions = evalHelper(this.props.dataAndOptions).chart;

    const Tag = chartCreators[chartDataAndOptions.react_component_name];
    const data = chartDataAndOptions.chart_data;
    const options = this.customizeOptions(evalHelper(chartDataAndOptions.options), this.props);

    let onExportChart = this.props.exportChart;

    let slideOverlay, onclick;
    if (this.enableAddToSlideDeck()) {
      if (!onExportChart) {
        onclick = ((e) => {
          e.stopPropagation();
          e.preventDefault();
        });
        throw "You need to pass in an exportChart prop in order to add charts to slidedecks";
      } else {
        onclick = onExportChart(this, this.props.title);
      }

      // TODO(SI): should just make a custom button and not reuse contextButton like this.
      if (!options.library.lang) { options.library.lang = {}; }
      options.library.lang.customContextButtonTitle = "Add to slide deck";
      options.library.exporting = {
        enabled: this.props.showExportButton,
        buttons: {
          contextButton: {
            _titleKey: "customContextButtonTitle",
            enabled: this.props.showExportButton,
            verticalAlign: "bottom",
            onclick: onclick,
            symbol: "addToSlideDeck",
            symbolStroke: "#0065A4",
            theme: {
              states: {
                hover: {
                  stroke: "#0065A4",
                  fill: "white"
                }
              }
            }
          },
          customButton: {
            enabled: false
          }
        }
      };

      slideOverlay = <AddToSlideDeckOverlay />;
    }

    const downloadButton = () => {
      const digitsRegex = /\d+/;
      const year = this.props.title.match(digitsRegex)[0];
      return this.props.title.match("Countries by combined") && <DownloadButton data={data} year={year} />;
    };

    return (
      <div style={{ overflow: "hidden", height: "inherit" }}>
        <h3 style={{ textAlign: "center", fontSize: "18px" }}>{this.props.title}</h3>
        <div ref={this.chartContainerWrapper} style={this.containerStyles()} className="chart-container-wrapper">
          {!options.library.hideValues && downloadButton()}
          <Tag data={data} {...options} />
          {slideOverlay}
        </div>
      </div>
    );
  }
}

ChartkickChart.propTypes = {
  dataAndOptions: PropTypes.string,
  title: PropTypes.string,
  showExportButton: PropTypes.bool,
  exportChart: PropTypes.func // first argument will be the MouseEvent, 'this' will be the ChartkickChart component.
};

export default ChartkickChart;
